Controller.$inject = [];

function Controller() {

}

export function HuiPageSubHeader() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            isSticky: '<'
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui hui-sub-header" 
                          ng-class="{'is-sticky': $huiCtrl.isSticky}"
                          ng-transclude></div>`;
        }
    };
}